import React, { useEffect, useRef } from 'react';

export const useIframeMessage = <T>(
  ref: React.RefObject<HTMLIFrameElement>,
  allowedOrigin: string,
  handler: (data: T) => void,
) => {
  const handlerRef = useRef((message: MessageEvent) => {
    if (message.source !== ref?.current?.contentWindow || message.origin !== allowedOrigin) {
      return;
    }

    handler(message.data);
  });

  useEffect(() => {
    window.addEventListener('message', handlerRef.current);

    return () => window.removeEventListener('message', handlerRef.current);
  }, []);
};
